import { COLORS } from "../../../constants/colors";

const submitButton = {
  width: "172px",
  height: "43px",
  borderRadius: "5px",
  fontWeight: "600",
  backgroundColor: "#19b2ab !important",
  color: "#21262f !important",
};

export const customChannelSelectorStyles = {
  form: {
    width: "100%",
    "& input": {
      color: "#ffffff",
      background: "rgba(1, 1, 1, 0)",
      border: 0,
    },
  },
  chartTitle: {
    fontSize: "18px",
    position: "relative",
    "& input": {
      padding: "5px 41px 9px",
      minWidth: "50px",
      width: "calc(100%)",
      "&:hover": {
        padding: "4px 40px 8px",
        borderRadius: "4px",
        border: "solid 1px rgba(156, 156, 156, 0.5)",
      },
      "&:focus": {
        padding: "4px 40px 8px",
        borderRadius: "4px",
        border: "solid 1px #9c9c9c",
        backgroundColor: "rgba(44, 58, 72, 0.3)",
      },
      "&:focus-visible": {
        outline: 'none'
      }
    },
    "&:hover": {
      "& input": {
        padding: "4px 40px 8px",
        borderRadius: "4px",
        border: "solid 1px rgba(156, 156, 156, 0.5)",
      },
    },
  },
  titleContainer: {
    display: "flex",
    gap: "40px",
    marginBottom: "12px",
    alignItems: "center",
    padding: "10px 0px 10px 0px",
  },
  titleIcon: {
    height: "40px",
    width: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "-5px",
    left: "0px",
  },
  chartSubtitle: {
    fontSize: "16px",
    border: "1px solid #9c9c9c",
    backgroundColor: "rgba(44, 58, 72, 0.3)",
    height: "43px",
    width: "400px",
    display: "flex",
    "& div": {
      lineHeight: "40px",
      textAlign: "center",
      "&:nth-child(1)": {
        minWidth: "40px",
        fontSize: "12px",
        borderRight: "1px solid #9c9c9c",
      },
      "&:nth-child(2) input": {
        padding: "0 10px",
        height: "40px",
        width: '100%',
        "&:focus-visible": {
          outline: 'none'
        }
      },
    },
  },
  body: {
    marginTop: "50px",
  },
  searchControl: {
    fontSize: "10px",
  },
  searchInput: {
    width: "300px",
    height: "26px",
    padding: "8px",
    marginTop: "5px",
    borderRadius: "2px",
    backgroundColor: "#2c3a48 !important",
    "&:focus-visible": {
      outline: 'none'
    }
  },
  showAll: {
    cursor: "pointer",
    marginTop: "8px",
    color: "#19b2ab",
  },
  tableContainer: {
    height: "100%",
    marginTop: "32px",
  },
  tableMessage: {
    fontSize: "12px",
    whiteSpace: "pre-wrap",
  },
  noMatchFound: {
    width: "100vw",
    height: "535px",
    display: "table-cell",
    verticalAlign: "middle",
    textAlign: "center",
  },
  table: {
    height: "562px",
    "& .MuiTableCell-stickyHeader": {
      backgroundColor: `${COLORS.backgroundColor} !important`,
    },
    "& .MuiTable-stickyHeader": {
      "borderCollapse": "collapse !important",
    },
    "& input[type='checkbox']": {
      appearance: "none",
      margin: 0,
      font: "inherit",
      width: "20px",
      height: "20px",
      border: "0.15em solid #19b2ab",
      borderRadius: "0.15em",
      transform: "translateY(3px)",
    },
    "& input[type='checkbox']:checked": {
      "accentColor": "#19b2ab",
      appearance: "auto",
    },
    "&::after": {
      display: "block",
      position: "absolute",
      bottom: 0,
      left: 0,
      height: "100px",
      width: "100%",
      backgroundImage: `linear-gradient(to right, rgba(255,255,255,0), ${COLORS.backgroundColor})`,
      zIndex: 9999,
      pointerEvents: "none",
    },
  },
  disabledRow: {
    opacity: "0.5",
    "& input[type='checkbox']": {
      border: "0.15em solid #ffffff",
    },
  },
  headerHolder: {
    height: "38px",
    "& .MuiTableCell-root": {
      fontSize: "16px",
      fontWeight: "500",
      fontFamily: "Inter",
      fontStretch: "normal",
      lineHeight: "normal",
      color: "#ffffff",
    },
  },
  selectedRow: {
    backgroundColor: "rgba(25, 178, 171, 0.2)",
  },
  unSelectedRow: {
    backgroundColor: "none",
  },
  graphHeader: {
    fontSize: "16px",
  },
  graphSubHeader: {
    marginLeft: "10px",
    fontSize: "10px",
    opacity: "0.7",
  },
  graph: {
    height: "220px",
    marginTop: "20px",
    overflowY: "scroll",
  },
  linesContainer: {
    marginTop: "20px",
    marginBottom: "20px",
    height: "300px",
    overflowY: "scroll"
  },
  lines: {
    height: "320px",
    marginTop: "20px",
  },
  line: {
    display: "inline-flex",
    width: "fit-content",
    padding: "6px 6px 6px 10px",
    margin: "0 8px 8px 0",
    borderRadius: "10px",
    backgroundColor: "#252d39",
    fontSize: "10px",
    height: "32px",
  },
  lineTitle: {
    height: "20px",
    verticalAlign: "middle",
    paddingTop: "2.5px",
  },
  lineTitleVar: {
    height: "20px",
    verticalAlign: "middle",
    paddingTop: "3px",
    marginLeft: "8px",
    color: "#84eb80"
  },
  lineIcon: {
    height: "20px",
    verticalAlign: "middle",
    marginLeft: "8px",
  },
  controller: {
    display: "flex",
  },
  controllerLeft: {
    "flexGrow": 1,
  },
  controllerRight: {},
  submitButton: {
    ...submitButton,
    cursor: "pointer",
  },
  disabledSubmitButton: {
    ...submitButton,
    opacity: "0.5",
  },
  cancelButton: {
    marginLeft: "40px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#19b2ab",
    cursor: "pointer",
  },
  deleteButton: {
    marginLeft: "8px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#ff5252",
  },
  customChartDisclaimer: {
    fontSize: "10px",
    opacity: "0.7",
    textAlign: "center"
  }
};